(() => {
  const HOST = '[data-bv-show="reviews"]';
  const STYLE_ATTR = 'data-custom-bv-reviews-heading';
  const WAIT_MS = 50;
  const WAIT_MAX_MS = 20000;
  const watching = new WeakSet();

  const headingCss = `
    #bv_review_maincontainer > div:first-child {
      margin-top: 0 !important;
      padding-top: 0 !important;
    }

    #bv_review_maincontainer h2:first-of-type {
      margin-top: 0 !important;
      margin-block-start: 0 !important;
      padding-top: 0 !important;
      font-family: var(--font-heading) !important;
      font-weight: var(--font-heading-weight) !important;
      font-style: var(--font-heading-style) !important;
      font-size: var(--bv-reviews-heading-size, var(--font-size-heading-3-base)) !important;
      line-height: var(--line-height-heading) !important;
      letter-spacing: var(--font-heading-base-letter-spacing, 0) !important;
      text-transform: var(--font-heading-text-transform, none) !important;
      color: var(--color-text) !important;
    }

    :host([data-has-heading="true"]) #bv_review_maincontainer h2:first-of-type {
      display: none !important;
    }
  `;

  const inject = (host) => {
    const root = host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector(`style[${STYLE_ATTR}]`)) {
      const style = document.createElement('style');
      style.setAttribute(STYLE_ATTR, '');
      style.textContent = headingCss;
      root.appendChild(style);
    }
    return true;
  };

  const watch = (host) => {
    if (watching.has(host)) return;
    watching.add(host);

    let shadowObserved = false;

    const ensure = () => {
      if (!inject(host)) return;
      if (!shadowObserved && host.shadowRoot) {
        shadowObserved = true;
        new MutationObserver(() => inject(host)).observe(host.shadowRoot, { childList: true });
      }
    };

    ensure();
    new MutationObserver(ensure).observe(host, { attributes: true, attributeFilter: ['data-bv-ready'] });

    const started = Date.now();
    const timer = setInterval(() => {
      ensure();
      if (shadowObserved || Date.now() - started > WAIT_MAX_MS) clearInterval(timer);
    }, WAIT_MS);
  };

  const init = (root = document) => {
    root.querySelectorAll(HOST).forEach(watch);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState !== 'loading') init();
})();
